import { acceptHMRUpdate, defineStore } from 'pinia';
import { ref } from 'vue';
import axios from 'axios';

export const usePharmacyStore = defineStore('pharmacy', () => {
    const all = ref({ data: [] });

    const active = ref({});

    const reset = () => {
        all.value = { data: [] };
    };

    const search = (params) => {
        return axios.get('/api/v1/pharmacies', { params });
    };

    const store = (params) => {
        return axios.post('/api/v1/pharmacies', params);
    };

    const update = (params) => {
        return axios.patch('/api/v1/pharmacies/' + params.hash, params);
    };

    const destroy = (params) => {
        return axios.delete('/api/v1/pharmacies/' + params.hash);
    };

    const accessPharmacy = (payload) => {
        return axios.get('/api/v1/pharmacies/' + payload.hash + '/access');
    };

    const stopAccessPharmacy = () => {
        return axios.get('/api/v1/pharmacies/stop-access');
    };

    return {
        all,
        active,
        reset,
        search,
        store,
        update,
        destroy,
        accessPharmacy,
        stopAccessPharmacy,
    };
});

// HMR
if (import.meta.hot) {
    import.meta.hot.accept(acceptHMRUpdate(usePharmacyStore, import.meta.hot));
}
